var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"CustomSMSButton d-flex align-items-center justify-content-center",on:{"click":function($event){return _vm.toggleModal('SMSModal')}}},[_c('i',{staticClass:"fas fa-envelope"})])
}
var staticRenderFns = []

export { render, staticRenderFns }